import "./App.css";
import HomePage from "./components/homePage";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import PrivacyPolicy from "./components/privacyPolicy";
import TermsAndConditions from "./components/termsAndConditions";
import MainPage from "./components/mainPage";
import PageMeta from "./components/pageMeta";
import About from "./components/about";

function App() {
  return (
    <BrowserRouter>
    <PageMeta />
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/muscleUp" element={<HomePage />} />
        <Route path="/muscleUp/privacy-policy" element={<PrivacyPolicy />} />
        <Route
          path="/muscleUp/terms-and-conditions"
          element={<TermsAndConditions />}
        />
        <Route
          path="/muscleUp/our-philosophy"
          element={<Navigate to="/muscleUp#philosophy" replace />}
        />
        <Route path="/about" element={<About />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
